import {
    Cell,
    IconOpenInNewTab,
    Link,
    MiniGrid,
    MiniGridHeaderRow,
    MiniGridRow,
    TextCell,
} from '@direct-frontend/components';
import { noop } from '@direct-frontend/stdlib';
import { productsRoute } from '#shared/lib/routes';
import { getCharacteristicValueFilterSearchParams } from '../../lib/filters/getCharacteristicValueFilterSearchParams';
import { type CharacteristicValuesListUIProps } from './types';
import styles from './CharacteristicValuesList.module.css';

export function CharacteristicValuesListUI({ values, characteristicSlug }: CharacteristicValuesListUIProps) {
    if (values.length === 0) {
        return (
            <MiniGrid>
                <MiniGridHeaderRow>
                    <TextCell align="center" title="Нет значений" />
                </MiniGridHeaderRow>
            </MiniGrid>
        );
    }

    return (
        <MiniGrid>
            {values.map((value, index) => (
                <MiniGridRow id={String(index)} key={index} className={styles.row} onHoverChange={noop}>
                    <TextCell width="full" title={value} isTruncated />
                    {characteristicSlug && (
                        <Cell type="Icon" isGrowable={false} className={styles.cellButtonOpen}>
                            <Link
                                color="supplementary"
                                href={productsRoute.getUrl({
                                    searchParams: getCharacteristicValueFilterSearchParams(characteristicSlug, value),
                                })}
                                target="_blank"
                                rel="noreferrer"
                                aria-label={`Показать товары со значением «${value}»`}
                            >
                                <IconOpenInNewTab role="supplementary" size="20" />
                            </Link>
                        </Cell>
                    )}
                </MiniGridRow>
            ))}
        </MiniGrid>
    );
}
